import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import DoorFrontIcon from '@mui/icons-material/DoorFront';
import HomeIcon from '@mui/icons-material/Home';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import { height } from '@mui/system';
import Portal from '@mui/material/Portal';

export default function Navigation(props) {
    const {setCurrentScreen, currentScreen} = props;

    return (
        <Portal>
            <Paper 
                id="bottom-nav" 
                sx={{ 
                    position: 'fixed', 
                    bottom: 0, 
                    left: 0, 
                    right: 0, 
                    zIndex: 1300,
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    overflow: 'hidden',
                    background: 'linear-gradient(135deg, rgba(20,20,20,0.92) 0%, rgba(28,28,28,0.92) 60%, rgba(38,38,38,0.92) 100%)',
                    backdropFilter: 'blur(10px)',
                    borderTop: '1px solid rgba(255,255,255,0.08)',
                    boxShadow: '0 -12px 24px rgba(0,0,0,0.35), 0 -2px 8px rgba(0,0,0,0.2)',
                    pb: 'max(6px, env(safe-area-inset-bottom))'
                }} 
                elevation={0}
            >
                <Box sx={{ width: "100%" }}>
                    <BottomNavigation
                        showLabels
                        value={currentScreen}
                        onChange={(event, newValue) => {
                            setCurrentScreen(newValue);
                        }}
                        sx={{
                            background: 'transparent',
                            '& .MuiBottomNavigationAction-root': {
                                color: 'rgba(255,255,255,0.72)',
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '0.9rem',
                                minWidth: 80,
                                paddingTop: 1,
                                paddingBottom: 1,
                                transition: 'color 120ms ease',
                                '& .MuiSvgIcon-root': { fontSize: 26 },
                                '&.Mui-selected': {
                                    color: '#90caf9',
                                },
                                '&.Mui-selected::after': {
                                    content: '""',
                                    display: 'block',
                                    height: 3,
                                    width: 28,
                                    margin: '4px auto 0 auto',
                                    borderRadius: 2,
                                    background: 'linear-gradient(90deg, #90caf9 0%, #42a5f5 100%)'
                                }
                            }
                        }}
                    >
                        <BottomNavigationAction  label="Prospecting"  icon={<DoorFrontIcon />} />
                        <BottomNavigationAction  label="leads" icon={<HomeIcon />} />
                        <BottomNavigationAction  label="closed" icon={<SolarPowerIcon />} />
                    </BottomNavigation>
                </Box>
            </Paper>
        </Portal>
    );
}